import { Component } from '@angular/core';
import { GoogleAuthService } from 'src/app/Services/google-auth.service';

@Component({
    selector: 'app-google-signin',
    templateUrl: './google-signin.component.html',
    styleUrl: './google-signin.component.css',
    standalone: false
})
export class GoogleSigninComponent {
  user: any = null;
  isLoading = false;
  errorMessage: string = '';
  isInitialized = false;

  constructor(private googleAuthService: GoogleAuthService) { }

  ngOnInit(): void {
    this.userInitialized();
  }

  userInitialized() {
    this.googleAuthService.getUser().subscribe(user => {
      this.user = user;
    });

    this.googleAuthService.isGoogleInitialized().subscribe(isInitialized => {
      this.isInitialized = isInitialized;
    });
  }

  signIn(): void {
    if (this.isLoading || !this.isInitialized) return;

    this.isLoading = true;
    this.errorMessage = '';

    this.googleAuthService.signIn().catch(error => {
      // The service layer now handles showing user-facing errors (e.g., via SweetAlert).
      // The component's responsibility is to manage its own state.
      console.error('Error signing in:', error);
      if (error.code !== 'auth/popup-closed-by-user' && error.code !== 'auth/cancelled-popup-request') {
        this.errorMessage = 'Failed to sign in with Google. Please try again.';
      }
    }).finally(() => {
      this.isLoading = false;
    });
  }

}
